import React, { useState } from "react";
import { Box, CardMedia, Typography } from "@material-ui/core";
import useStyles from "./styles.js";
import img from "../../../assets/card2.png";
import velaGreen from "../../../views/Catalogue/velaGreen.png";
import velaYellow from "../../../views/Catalogue/velaYellow.png";
import velaWhite from "../../../views/Catalogue/velaWhite.png";
import velaRed from "../../../views/Catalogue/velaRed.png";
import reli from "../../../assets/velas/Religiosas/SEA_7359.jpg";

const ProductDetail = () => {
  let fotos = [velaGreen, velaYellow, velaWhite, velaRed];

  let vela1 = {
    nombre: "C026 Liso Repuesto ",
    codigo: "C02600003",
    peso: 113.4,
    altura: 7.5,
    diametroSup: 4.5,
    diametroInf: 4,
    duracion: 5,
  };

  let vela2 = {
    nombre: "Vela Demo ",
    codigo: "C02600003",
    peso: 113.4,
    altura: 7.5,
    diametroSup: 4.5,
    diametroInf: 4,
    duracion: 5,
  };

  let url = window.location.href;
  let colorSelector = url[url.length - 1];

  const [color, setColor] = useState(parseInt(colorSelector));

  const color0 = (e) => {
    setColor(e.currentTarget.value);
  };

  const classes = useStyles();

  return (
    <Box component="div" className={classes.productContainer}>
      <CardMedia
        component="img"
        image={color == 7 ? reli : fotos[color]}
        className={classes.productImg}
      />
      <Box component="div" className={classes.details}>
        <Typography className={classes.productName} variant="h5">
          {color == 7 ? vela2.nombre : vela1.nombre}
        </Typography>
        <Box component="div" className={classes.code}>
          <Typography className={classes.specs} variant="body1">
            Product Code
          </Typography>
          <Typography className={classes.specsValuesCode} variant="body2">
            {color == 7 ? vela2.codigo : vela1.codigo}
          </Typography>
        </Box>
        <Box component="div" className={classes.features}>
          <Typography className={classes.specs} variant="body1">
            Peso <br />
            (g)
          </Typography>
          <Typography className={classes.specs} variant="body1">
            Altura (cm)
          </Typography>
          <Typography className={classes.specs} variant="body1">
            Diametro sup. (cm)
          </Typography>
          <Typography className={classes.specs} variant="body1">
            Diametro inf. (cm)
          </Typography>
          <Typography className={classes.specs} variant="body1">
            Duracion aprox (h)
          </Typography>
          <Typography className={classes.specsValues} variant="body2">
            {vela1.peso}
          </Typography>
          <Typography className={classes.specsValues} variant="body2">
            {vela1.altura}
          </Typography>
          <Typography className={classes.specsValues} variant="body2">
            {vela1.diametroSup}
          </Typography>
          <Typography className={classes.specsValues} variant="body2">
            {vela1.diametroInf}
          </Typography>
          <Typography className={classes.specsValues} variant="body2">
            {vela1.duracion}
          </Typography>
        </Box>
      </Box>{" "}
      {color == 7 ? (
        ""
      ) : (
        <div className={classes.btnCont}>
          <button className={classes.btn0} onClick={color0} value={0}></button>
          <button className={classes.btn1} onClick={color0} value={1}></button>
          <button className={classes.btn2} onClick={color0} value={2}></button>
          <button className={classes.btn3} onClick={color0} value={3}></button>
        </div>
      )}
    </Box>
  );
};

export default ProductDetail;
